/**
 * @desc Export table layout configuration.
 * @example
 * import { layoutConfig } from 'config/table-configs/prior-auth-list.js';
 */
 export const layoutConfig = {
    dimensions: {
        maxHeight: 260,
        padding: 0,
    },
    columnWidth: {
        eocNumber: 60,
        requestDate: 60,
        drugName: 120,
        status: 120,
        prescriberName: 60,
        priorAuthType: 60,
        authorizationStartDate: 80,
        authorizationEndDate: 80
    },
    columnIcons: {
        status: {
            name: 'info',
            path: 'values.status'
        }
    }
};
